import style from '../styles/form.module.css'

import classNames from 'classnames/bind'
import useTranslation from 'next-translate/useTranslation'
import { useState, useEffect, useRef } from 'react'
import useAuth from '../hooks/useAuth'

export default function PayNow ({ id = '', active, instant, amount, onCopy, onSubmit, onCancel, onError }) {
  const { t } = useTranslation('main')
  const c = classNames.bind(style)
  const currency = 'SGD'
  const paynowQR = useRef()
  const { authedFetch } = useAuth()

  const [loading, setLoading] = useState(true)
  const [reference, setReference] = useState(id)
  // Disable manual PayNow
  // const [allowManual, setAllowManual] = useState(false)

  useEffect(() => {
    async function fetchRef () {
      const response = await authedFetch(`/api/transfer?type=P&amount=${amount}&id=${id}&currency=${currency}`)
      if (response.status !== 200) {
        const json = await response.json()
        onError(json.detail)
        return
      }
      paynowQR.current.src = URL.createObjectURL(await response.blob())
      if (!id) {
        setReference(response.headers.get('X-reference'))
      }
      // setAllowManual(response.headers.get('X-xfers') !== 'true')
      setLoading(false)
    }
    paynowQR.current.src = ''
    active !== false && amount >= 0 && fetchRef()
  }, [active])

  const handleComplete = mode => {
    onSubmit()
    authedFetch('/api/payment-intent', {
      method: 'PUT',
      body: JSON.stringify({
        PaymentIntentId: reference,
        Status: 'CustomerSent',
        Comment: mode
      })
    })
  }

  const handleCancel = () => {
    if (window.confirm(t('paynow-cancel-confirm'))) {
      onCancel()
      authedFetch('/api/payment-intent', {
        method: 'PUT',
        body: JSON.stringify({
          PaymentIntentId: reference,
          Status: 'Cancelled'
        })
      })
    }
  }

  return (
    <div className={c('paynowform')}>
      {active !== undefined && (
        <div className={c('leadingsuccess', { success: active })}>
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 70 70'>
            <path fill='#D8D8D8' d='M35,60 C21.1928813,60 10,48.8071187 10,35 C10,21.1928813 21.1928813,10 35,10 C48.8071187,10 60,21.1928813 60,35 C60,48.8071187 48.8071187,60 35,60 Z M23.6332378,33.2260427 L22.3667622,34.7739573 L34.1433655,44.40936 L47.776114,27.6305926 L46.223886,26.3694074 L33.8566345,41.59064 L23.6332378,33.2260427 Z' />
            <circle stroke='#F6C358' cx='35' cy='35' r='24' strokeWidth='1.3' strokeLinecap='round' fill='transparent' />
            <polyline strong='#F6C358' strokeWidth='1.3' points='23 34 34 43 47 27' fill='transparent' />
          </svg>
        </div>
      )}
      <div>
        <h3>{t('banktransfer-title')}</h3>
        <p>
          {instant
            ? t('paynow-instant-info')
            : t('paynow-info')}
        </p>
        <div className={c('inputfield')} style={{ position: 'relative' }}>
          <img ref={paynowQR} style={{ backgroundColor: '#fff', filter: 'contrast(.61) sepia() brightness(1.5) hue-rotate(255deg) saturate(2.4) contrast(2.2)', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', border: '5px solid #fff', borderRadius: '.3em', boxShadow: loading ? '' : '0 0 0 1px #040404', width: '260px', height: '260px' }} width={260} height={260} />
          <img src={loading ? '/images/loader.svg' : '/images/paynow.png'} style={{ border: '2px solid #fff', background: '#fff', position: 'absolute', width: '64px', top: '117px', left: '101px' }} />
        </div>
        <br />
        <button onClick={() => handleComplete('PayNow QR')}>{t('paynow-qrcomplete-button')}</button>
        <br />
        <br />
        <br />
        {/* {allowManual && (
          <>
            <br />
            <h3>{t('paynow-manualtitle')}</h3>
            <p>{t('paynow-manual')}</p>
            <div className={c('inputfield')}>
              <label htmlFor='uenro'>{t('paynow-recipientuen')}:</label>
              <input type='text' id='uenro' readOnly defaultValue='200907537MDBS' />
              <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('uenro')} title={t('paynow-copy')}>
                <img src='/images/copy.svg' alt={t('paynow-copy-alt')} />
              </button>
              <div>S.T.A.R. Grams Savings Account</div>
            </div>
            <div className={c('inputfield')}>
              <label htmlFor='amountro'>{t('paynow-amount')} ({currency}):</label>
              <input type='text' id='amountro' readOnly key={amount} defaultValue={(amount || 0).toFixed(2)} />
              <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('amountro')} title={t('paynow-copy')}>
                <img src='/images/copy.svg' alt={t('paynow-copy-alt')} />
              </button>
            </div>
            <div className={c('inputfield')}>
              <label htmlFor='referencero'>{t('paynow-reference')}:</label>
              <input type='text' id='referencero' className={loading ? 'loadingshimmer' : ''} readOnly defaultValue={reference} key={reference} />
              <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('referencero')} title={t('paynow-copy')}>
                <img src='/images/copy.svg' alt={t('paynow-copy-alt')} />
              </button>
              <div>{t('paynow-reference-info')}</div>
            </div>
            <br />
            <button onClick={() => handleComplete('PayNow Manual')}>{t('paynow-manualcomplete-button')}</button>
            <br />
            <br />
            <br />
          </>
        )} */}
        <button className='light' onClick={handleCancel}>{t('paynow-cancel-button')}</button>
      </div>
    </div>
  )
}
